import { useEffect } from 'react';

/** Browser title: "<Page> · LIA". */
export function usePageTitle(page?: string) {
  useEffect(() => {
    document.title = page ? `${page} · LIA` : 'LIA by Estateflow';
  }, [page]);
}
